<script>
  import { cart } from "../models/cart.js";

  export let product;
  export let eventID = null;
  export let eventName;
  export let compact = false;

  let added = false;
  $: isInCart = $cart.some(
    (c) => c.id === product.id && c.event_id === eventID
  );

  // TODO: have the backend return the include_rentals attribute so we can limit 1 rental ticket per cart
  $: hasTicketWithRentals = $cart.find(
    (c) => c.product_type.name === "Ticket" && c.title.indexOf("Rentals") > -1
  );

  async function addItem(product) {
    if (eventID && !product.event_id) {
      product.event_id = eventID;
    }
    cart.addEventTicket(product);
    added = $cart.some((c) => c.id === product.id);

    if (added) {
      setTimeout(() => {
        added = false;
      }, 2500);
    }
  }

  async function removeItem(product) {
    if (eventID && !product.event_id) {
      product.event_id = eventID;
    }
    cart.removeEventTicket(product);
  }
</script>

{#if added}
  <p class="cart-success">
    <svg class="icon">
      <use href="/icons.svg#check" />
    </svg>
    Added to Cart!
  </p>
{:else if isInCart}
  <div class="cart-item-quantity">
    <!-- Only allow 1 rental ticket per order -->
    <!-- TODO: replace looking at the title with the product attribute include_rentals-->
    {#if product.product_type.id === 7 && product.title.indexOf("Rentals") === -1}
      <button
        class="btn btn-link cart-btn"
        on:click|stopPropagation={removeItem(product)}
      >
        <svg class="icon">
          <use href="/icons.svg#minus" />
        </svg>
      </button>
      <span class="cart-item-quantity-value">
        Qty: {$cart.reduce(
          (a, p) =>
            a + (p.id == product.id && p.event_id == eventID ? p.quantity : 0),
          0
        )}
      </span>
      <button
        class="btn btn-link cart-btn"
        on:click|stopPropagation={addItem(product)}
      >
        <svg class="icon">
          <use href="/icons.svg#plus" />
        </svg>
      </button>
    {:else}
      <button
        class="btn btn-expanded event-btn"
        class:btn-plain={compact}
        on:click={removeItem(product)}
      >
        <svg class="icon">
          <use href={"/icons.svg#clear"} />
        </svg>
        Remove from Cart
      </button>
    {/if}
  </div>
  <!-- Only allow 1 rental ticket per order -->
  <!-- TODO: replace looking at the title with the product attribute include_rentals-->
  <div>
    {#if hasTicketWithRentals && product.product_type.name == "Ticket" && product.title.indexOf("Rentals") > -1}
      <p>
        <b
          >You already have one event rental ticket in your cart. Limit 1 rental
          ticket per order.</b
        >
      </p>
    {/if}
  </div>
{:else}
  <button
    class="btn event-btn"
    class:btn-plain={compact}
    on:click={() => addItem(product)}
    disabled={hasTicketWithRentals &&
      hasTicketWithRentals.event_id !== eventID &&
      product.title.indexOf("Rentals") > -1}
  >
    <svg class="icon">
      <use href={"/icons.svg#cart"} />
    </svg>

    Add to Cart
  </button>
  <!-- Only allow 1 rental ticket per order -->
  <!-- TODO: replace looking at the title with the product attribute include_rentals-->
  <div>
    {#if hasTicketWithRentals && product.product_type.name == "Ticket" && product.title.indexOf("Rentals") > -1}
      <p>
        <b
          >You already have one event rental ticket in your cart. Limit 1 rental
          ticket per order.</b
        >
      </p>
    {/if}
  </div>
{/if}

<style>
  .cart-item-quantity {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .cart-btn {
    padding: 0 var(--spacing-sm);
  }
  .cart-success {
    color: var(--col-success);
    padding: 0 var(--spacing-sm);
    margin: var(--spacing-xs) 0;
    line-height: var(--line-height);
  }

  .event-btn {
    background-color: var(--col-accent-2-l);
    border: 1px solid var(--col-accent-2-l);
    border-radius: var(--border-radius);
  }
</style>
